document.querySelectorAll(".site-nav__label").forEach((x) =>
	x.addEventListener("mouseenter", function (event) {
		document
			.querySelectorAll(".drop-nav")
			.forEach((x) => {console.log(x); x.classList.remove("display")});
		
		const header = document.querySelector(".site-header")
		header.classList.add('menu-dropped')

		switch (event.target.id) {
			case "shop-nav-link":
				document.querySelector(".shop-drop-nav").classList.add("display");
                break;
			case "explore-nav-link":
				document.querySelector(".explore-drop-nav").classList.add("display");
                break;
			case "about-nav-link":
				document.querySelector(".about-drop-nav").classList.add("display");
                break;
		}
	})
);

document
	.querySelectorAll(".drop-nav").forEach(x=>
        x.addEventListener("mouseleave", function (event) {
			const header = document.querySelector(".site-header")
			header.classList.remove('menu-dropped')
            event.target.classList.remove("display");
        })
    )